import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function sendEvento(
  uname,
  token,
  titolo,
  data,
  categorie,
  corsi,
  exStudenti,
  id,
  ora,
  blacklist,
  orarioFine,
  descrizione
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "sendEvento.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function() {
        resolve();
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      titolo: titolo,
      data: data,
      categorie: categorie,
      corsi: corsi,
      ex_studenti: exStudenti,
      id_evento: id,
      ora: ora,
      blacklist: blacklist,
      orario_fine: orarioFine,
      descrizione: descrizione,
    });

    req.write(postData);

    req.end();
  });
}
